
<v-text-field
    :required       = "required"
    :rules          = "rules"
    :label          = "$t(label)"
    ref             = "datePicker"
    class           = "datetime-input"
    :class          = "deadline ? 'red-text-input ': '' + color ? color : ''"
    :value          = "fieldvalue"
    :error-messages = "errorMessages"
    autocomplete    = "off"
    autocorrect     = "off"
    autocapitalize  = "off"
    spellcheck      = "false"
    :readonly       = "readonly"
    :disabled       = "readonly"
    :hide-details   = "hideDetails"
    :dense          = "dense"
    :outlined       = "outlined"
    :prepend-icon   = "prependIcon"
    :background-color = "backgroundColor"
/>
